import Dexie, { Table } from "dexie"

export type FavoriteSong = {
  url: string

  name: string
  artist: string

  songimg: string

  trackTime?: string

  link?: string

  type?: string

  originalPlaylistId?: string | number | null
  originalPlaylistTitle?: string | null

  savedAt: Date
}

class FavoritesDB extends Dexie {
  favorites!: Table<FavoriteSong, string>

  constructor() {
    super("FavoritesDB")

    this.version(1).stores({
      favorites:
        "&url,name,artist,songimg,trackTime,type,originalPlaylistId,originalPlaylistTitle,savedAt",
    })
  }
}

export const db = new FavoritesDB()